/* eslint-disable */
import React from 'react';
import { TableProps, TableStyles } from 'react-data-table-component';
import { Table as TableAntd } from 'antd';
import { withTheme, ThemeProps, DefaultTheme } from 'styled-components';
import { Container } from './styles';

interface ITable
    extends Omit<TableProps<any>, 'theme'>,
        ThemeProps<DefaultTheme> {
    page?: number;
    lastPage?: number;
    isLoading: boolean;
    onChangePage: (value: number) => void;
    onChangeSelectedRows?: (selected: {
        allSelected: boolean;
        selectedCount: number;
        selectedRows: [];
    }) => void;
    loadingMessage?: string;
}

const Table: React.FC<ITable> = ({
    data,
    page = 1,
    lastPage = 1,
    loadingMessage = 'Carregando dados da tabela...',
    onChangePage,
    onChangeSelectedRows,
    isLoading,
    columns,
    theme,
    customStyles,
    ...props
}): JSX.Element => {
    const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>(
        [],
    );
    const defaultCustomStyles: TableStyles = {
        rows: {
            style: {
                minHeight: '60px', // override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                fontSize: theme.fontSizes.default,
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
            },
        },
    };

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Container>
            <TableAntd
                rowSelection={rowSelection}
                dataSource={data}
                columns={columns}
                direction="ltr"
            />
        </Container>
    );
};

export default withTheme(Table);
